<ul class="nav nav-tabs mt-4">
    <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: selMenu == 'region' }" (click)="selectMenu('region')">Region</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: selMenu == 'sub-region' }"
            (click)="selectMenu('sub-region'); getAllList()">Sub-region</a>
    </li>

</ul>

<section class="mt-2" *ngIf="selMenu == 'region'">
    <span style="float: right;" class="mb-2"><button class="btn btn-secondary mt-2" (click)="add(addEditCategory)"><i
                class="fa fa-plus-circle" aria-hidden="true"></i> Add Region</button></span>
    <table class="table table-hover white_box shadow" style="margin-top: 10px;">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Region Name</th>
                <th scope="col">Image</th>
                <th scope="col">Sub-Region</th>
                <th scope="col">Status</th>
                <th scope="col" class="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of allRegionList; let i = index;">
                <th scope="row">{{i + 1}}</th>
                <td>{{item?.name | titlecase}}</td>

                <td> <img loading="lazy" *ngIf="item.image" style="height: 5rem;" [src]="imgUrl + item.image"></td>
                <td width="400">
                    <div class="row">
                        <ng-container *ngFor="let c of item.subRegions">
                            <span class="sub-cate p-2 m-2 "> {{c.name}} <i class="fa fa-trash"
                                    (click)="deleteMapping(c?.memberShopRegionSubRegionMapping?.id)"></i></span>
                        </ng-container>
                    </div>
                </td>
                <td><span>{{item?.isDeleted?'In-Active' :'Active'}}</span></td>
                <td class="text-right">
                    <section class="d-flex justify-content-center">

                        <button class="btn btn-info" (click)="add(addEditCategory,item)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Edit
                        </button>
                        <button class="btn btn-info ml-2" (click)="openAssign(AssignOption,item)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Assign Sub-Region
                        </button>
                        <button class="btn btn-danger ml-2" (click)="deleteSub(item?.regionId)">
                            <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>

                    </section>
                </td>
            </tr>
        </tbody>
    </table>
</section>

<ng-template #AssignOption let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Assign</h4>
        <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
    </div>
    <div class="modal-body">
        <section>
            <div><b>Sub Region : </b></div>
            <div class="my-4 row d-flex justify-content-center">
                <ng-container *ngFor="let c of assignCategoryList">
                    <span class="sub-cate p-2 m-2 "> <input type="checkbox" [(ngModel)]="c.checked" />
                        {{c.name}}</span>
                </ng-container>
            </div>
        </section>



        <duv class="d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" (click)="assignRelationshipSubmit()">
                Assign
            </button>
        </duv>
    </div>
</ng-template>


<section class="mt-2" *ngIf="selMenu == 'sub-region'">
    <span style="float: right;" class="mb-2"><button class="btn btn-secondary mt-2" (click)="add(addEditCategory)"><i
                class="fa fa-plus-circle" aria-hidden="true"></i> Add Sub-Region</button></span>
    <table class="table table-hover white_box shadow" style="margin-top: 10px;">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">Sub-Region Name</th>
                <th scope="col">Postal Code</th>
                <th scope="col">Image</th>
                <th scope="col">Status</th>
                <th scope="col" class="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of allList; let i = index;">
                <th scope="row">{{i + 1}}</th>
                <td>{{item?.name | titlecase}}</td>

                <td scope="row" width="400">
                    <div class="row">
                        <ng-container *ngFor="let i of item?.postalCode">
                            <span *ngIf="i" class="sub-cate p-2 m-2 ">{{i }}</span>
                        </ng-container>
                    </div>
                </td>

                <td> <img loading="lazy" *ngIf="item.image" style="height: 5rem;" [src]="imgUrl + item.image"></td>
                <td><span>{{item?.isDeleted?'In-Active' :'Active'}}</span></td>
                <td class="text-right">
                    <section class="d-flex justify-content-center">

                        <button class="btn btn-info" (click)="add(addEditCategory,item)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Edit
                        </button>


                        <button class="btn btn-danger  ml-2" (click)="deleteSub(item?.subRegionId)">
                            <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>

                    </section>
                </td>
            </tr>
        </tbody>
    </table>
</section>


<ng-template #addEditCategory let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Add/edit {{selMenu == 'region'?'Region':'Sub-Region'}}</h4>
        <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
    </div>
    <div class="modal-body">
        <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image w-100"
            [src]="imageBase64" alt="" />
        <img loading="lazy" *ngIf="selectedCategory?.image" class="map-search-listing-img mt-2 product-char-image w-100"
            [src]="imgUrl + selectedCategory?.image">

        <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()">
            <i class="fas fa-plus"></i> Upload {{selMenu == 'region'?'Region':'Sub-Region'}} Image
        </button>
        <input type="file" #upload (change)="saveProductCharSelectedImage($event)"
            class="suggestion-modal-pic-input d-none" accept="image/*" />


        <div class="row">
            <div class="form-group col-12">
                <label for="exampleInputEmail1">{{selMenu == 'region'?'Region':'Sub-Region'}} Name </label>
                <input type="text" [(ngModel)]="name" class="form-control" placeholder="Enter  Name">
            </div>

            <ng-container *ngIf="selMenu !='region'">
                <div class="form-group col-12">
                    <label for="exampleInputEmail1"> Metadata </label>
                    <textarea [(ngModel)]="metadata" class="form-control" placeholder="Enter Metadata"></textarea>
                </div>
            </ng-container>
            <ng-container *ngIf="selMenu !='region'">
                <div class="form-group col-12">
                    <label for="exampleInputEmail1"> Schema </label>
                    <textarea [(ngModel)]="schema" class="form-control" placeholder="Enter Schema"></textarea>
                </div>
            </ng-container>
            <ng-container *ngIf="selMenu !='region'">
                <div class="form-group col-12"
                    *ngFor="let code of postalCodeList; let ix = index; trackBy: trackByIndex">
                    <label for="exampleInputEmail1"> Postal Code </label>
                    <input type="text" [(ngModel)]="postalCodeValue[ix]" class="form-control"
                        placeholder="Enter Postal Code" (ngModelChange)="onPostalCodeChange(ix)">
                </div>
            </ng-container>

            <div class="d-flex justify-content-center" style="width: 100%; font-size: 2rem;" *ngIf="selMenu !='region'">
                <i class="fa fa-plus-circle" aria-hidden="true" (click)="addPostalCode()"></i>
            </div>

        </div>


        <duv class="d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" (click)="AddEditCategorySubmit()">
                Save
            </button>
        </duv>
    </div>
</ng-template>